/*
 This is the main swatch JS file that will build swatch CSS.

*/


(function(){

  const selectors = {
    swatchJSON: '#swatch-value-json',
    swatches: '.swatch-inputs',
  };

  function  _swatchPrepAndParse() {
      const $json = document.querySelector(selectors.swatchJSON);
      const content = JSON.parse($json.innerHTML);
      const hexes = content.filter((swatch) => swatch.type === 'hex').reduce((styles, swatch) => {
        const currentPlus = `${styles}.swatch-icon.${swatch.name} { background-color: ${swatch.value}; border-color: ${swatch.value} } .swatch-border-only.${swatch.name} { border-color: ${swatch.value} }`;
        return currentPlus;
      }, '');
      const images = content.filter((swatch) => swatch.type === 'image').reduce((styles, swatch) => {
        const currentPlus = `${styles}.swatch-icon.${swatch.name} { background-image: url(${swatch.value}); }`;
        return currentPlus;
      }, '');

      _createSheet(hexes);
      _createSheet(images);  
  }

  function _createSheet(styles) {
    const head = document.head || document.getElementsByTagName('header')[0];
    const style = document.createElement('style');
    head.appendChild(style);
    style.type = 'text/css';


    if (style.Stylesheet) {
        // IE8 and below.
      style.styleSheet.csstext = styles;
    } else {
      style.appendChild(document.createTextNode(styles));
    }
  }

  function _prepareSwatch(item) {
    const handle = item.getAttribute('data-source');
    const product = window.Shopify.products.find(function(pro) {
      return pro.handle === handle;
    });

    if (!product) {
      item.parentElement.removeChild(item);
      return;
    }

    const tags = product.tags;
    const colorTag = tags.find(function(tag){
      return tag.toLowerCase().indexOf('color-') !== -1;
    });

    if (!colorTag) {
      item.parentElement.removeChild(item);
      return;
    }

    const color = colorTag.split('-')[1];

    item.querySelector('.swatch-icon').classList.add(color.toLowerCase());

    console.warn('Handle', product, colorTag);
  }

  function _onPageSwatches() {
    const swatchesOnPage = document.querySelectorAll('.swatch-item');

    swatchesOnPage.forEach(_prepareSwatch);
    console.warn('ALL SWATCHES', swatchesOnPage);
  }


  _swatchPrepAndParse();
  _onPageSwatches()
})();